import React, { Component } from 'react';
import moment, { Moment } from 'moment';
import Animal from '../Entities/Animal';

interface StateTypes {
  timeRemaining: string | number | null;
  status: 'complete' | 'good' | 'okay' | 'bad' | 'critical';
}

interface PropTypes {
  dueDate: Animal['nextAssessmentDue'];
  assessmentStatus: Animal['assessmentStatus'];
}

class AssessmentCounter extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    timeRemaining: null,
    status: 'complete',
  };

  interval: number | null = null;

  determineRemainingTime = (
    currentDate: Moment,
    due: Moment,
  ): {
    status: StateTypes['status'];
    timeRemaining: StateTypes['timeRemaining'];
  } => {
    const timeLeft = moment.duration(due.diff(currentDate)).asHours();
    let status: StateTypes['status'] = 'good';
    if (timeLeft < 12 && timeLeft > 6) {
      status = 'okay';
    } else if (timeLeft <= 6 && timeLeft >= 3) {
      status = 'bad';
    } else if (timeLeft < 3) {
      status = 'critical';
    }
    let finalValue;
    if (timeLeft > 1) {
      finalValue = Math.round(timeLeft);
    } else if (timeLeft > 0) {
      finalValue = timeLeft.toFixed(2);
    } else {
      finalValue = 0;
    }
    return {
      status,
      timeRemaining: finalValue,
    };
  };

  refreshTime = (props: PropTypes) => {
    const { dueDate, assessmentStatus } = props;
    if (assessmentStatus === 'complete' || !assessmentStatus || !dueDate) {
      return null;
    }
    // dueDate is false if complete, so we shouldn't ever need this
    const currentDate = moment();
    const due = moment(dueDate);
    this.setState(this.determineRemainingTime(currentDate, due));
  };

  componentWillReceiveProps = (newProps: PropTypes) => {
    if (newProps.assessmentStatus !== this.props.assessmentStatus) {
      this.refreshTime(newProps);
    }
  };

  componentDidMount() {
    this.refreshTime(this.props);
    this.interval = setInterval(() => {
      this.refreshTime(this.props);
    }, 600000); // check every 10 mins
  }

  render() {
    const { assessmentStatus } = this.props;
    const { timeRemaining } = this.state;

    if (assessmentStatus === 'complete' || !assessmentStatus || timeRemaining === null) {
      return null;
    }

    return (
      <span
        title={`${assessmentStatus} assessment needed within ${timeRemaining}hrs`}
        className={`assesmentStatus ${this.state.status} is-size-7`}
      >
        <time>
          {timeRemaining < 1 && timeRemaining > 0
            ? `${(parseFloat(timeRemaining.toString()) * 60).toFixed(2)}mins`
            : `${timeRemaining}hrs`}
        </time>
      </span>
    );
  }
  componentWillUnmount() {
    if (!this.interval) return;
    clearInterval(this.interval);
  }
}

export default AssessmentCounter;
